import { ProductInstance, Translations } from '@repo/types';

export function validatePackageAvailability(
    availability: ProductInstance,
    numberOfTravellers: number,
    t: Translations,
) {
    const errors: string[] = [];
    if (availability.minEntrants && availability.minEntrants > numberOfTravellers) {
        errors.push(
            t.a_minimum_of_x_participants_is_required_to_book_this_product.parsed(
                availability.minEntrants.toString(),
            ),
        );
    }
    return errors;
}

export function validatePackageAvailabilities(
    selectedAvailabilities: ProductInstance[],
    numberOfTravellers: number,
    t: Translations,
) {
    const availabilitiesWithMinEntrantsTooHigh = selectedAvailabilities.filter(
        (p) => p.minEntrants && p.minEntrants > numberOfTravellers,
    );

    return availabilitiesWithMinEntrantsTooHigh.reduce(
        (acc, availability) => {
            const errors = validatePackageAvailability(availability, numberOfTravellers, t);
            if (errors.length > 0) {
                acc[availability.id] = errors;
            }
            return acc;
        },
        {} as Record<string, string[]>,
    );
}
